export const DEFAULT_AVATAR = `${import.meta.env.VITE_CDN_URL}/static/fallback-avatar.jpg`;

export const DEFAULT_IMG = `${import.meta.env.VITE_CDN_URL}/static/empty-image.svg`;
